import * as React from 'react'

import { Box, Card, Section, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type SurveyForm from 'modules/surveys/store/models/Form'

interface Props {
  form: SurveyForm
  canBeAnonymous: boolean
  canEditSurveyForm: boolean
}

function PrivacySettingV1({ form: surveyForm, canBeAnonymous, canEditSurveyForm }: Props) {
  const disabled = !canEditSurveyForm || !surveyForm.isDraft || !canBeAnonymous

  const form = React.useRef(
    new Form(surveyForm.toJS(), {
      anonymous: 'boolean',
    })
  ).current

  const onToggle = () => {
    form.setValues({
      anonymous: !form.get('anonymous').value,
    })
    submit()
  }

  const { performAction: submit } = useAsyncAction(() => form.save(surveyForm))
  return (
    <Section
      illustration="visibility"
      title={i18n.t('surveys.form.basic_info.anonymous.title')}
      description={i18n.t('surveys.form.basic_info.anonymous.subtitle')}
    >
      <Box gap="s16" aria-label="Here you can set your privacy settings">
        <Card>
          <Card.Title
            action={
              <TogglerCheckbox
                value={form.get('anonymous').value}
                onChange={onToggle}
                disabled={disabled}
              />
            }
          >
            {i18n.t('surveys.form.basic_info.form.labels.anonymous')}
          </Card.Title>
          <Card.Description>
            {i18n.t('surveys.form.basic_info.anonymous.disable_anonymous_description')}
          </Card.Description>
        </Card>
      </Box>
    </Section>
  )
}

export default observer(PrivacySettingV1)
